import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export default function Register() {
  const { t, register } = useApp();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(form.name, form.email, form.password); navigate('/account'); }
    catch (err) { toast.error(err.response?.data?.detail || 'Registration failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="register-page">
      <h1 className="font-display text-4xl">{t('auth.signup')}</h1>
      <form onSubmit={submit} className="mt-12 space-y-8">
        <div>
          <Label className="overline">{t('auth.name')}</Label>
          <Input required className="mt-2 rounded-none border-0 border-b border-foreground focus-visible:ring-0" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        </div>
        <div>
          <Label className="overline">{t('auth.email')}</Label>
          <Input type="email" required className="mt-2 rounded-none border-0 border-b border-foreground focus-visible:ring-0" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        </div>
        <div>
          <Label className="overline">{t('auth.password')}</Label>
          <Input type="password" required minLength={6} className="mt-2 rounded-none border-0 border-b border-foreground focus-visible:ring-0" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        </div>
        <button type="submit" disabled={loading} className="w-full bg-foreground text-background px-8 py-4 overline disabled:opacity-50" data-testid="register-submit">{loading ? '…' : t('auth.signup')}</button>
      </form>
      <p className="mt-8 text-sm font-light">{t('auth.haveaccount')} <Link to="/login" className="link-underline text-accent" data-testid="register-to-login">{t('auth.signin')} →</Link></p>
    </div>
  );
}
